<template>
  <div class="card card-pad-lg h-100">
    <div class="flex items-center justify-content-center gap-2 mb-5">
      <h3 class="section-title">Tiempos de Servicio</h3>
    </div>

    <div class="metrics-list">
      <div v-for="row in metrics" :key="row.label" class="metric-item">
        <div class="metric-header">
          <span class="metric-label">{{ row.label }}</span>
          <span class="metric-value">{{ row.value }} <span class="metric-unit">min</span></span>
        </div>
        <div v-if="row.caption" class="metric-caption">{{ row.caption }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ServiceTimesCard",
  props: {
    metrics: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
  .metrics-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .metric-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    background: #f9fafb;
    border-radius: 10px;
    padding: 14px 18px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    transition: background 0.2s ease, transform 0.2s ease;
  }


  .metric-item:hover {
    background: #f3f4f6;
  }

  .metric-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 28px;
  }

  .metric-label {
    font-size: 15px;
    font-weight: 600;
    color: #374151;
  }

  .metric-value {
    font-size: 18px;
    font-weight: 700;
    color: var(--primary-color);
  }

  .metric-unit {
    font-size: 12px;
    color: #6b7280;
  }

  .metric-caption {
    margin-top: 4px;
    font-size: 13px;
    color: #6b7280;
    line-height: 1.3;
  }

  .metric-item,
  .metric-header {
    transition: all 0.2s ease;
  }
</style>
